/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCostItemRequest
 */
export interface UpdateCostItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    costType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCostItemRequest
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCostItemRequest
     */
    monthlyCost?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCostItemRequest
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCostItemRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCostItemRequest
     */
    sunk?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCostItemRequest
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCostItemRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the UpdateCostItemRequest interface.
 */
export function instanceOfUpdateCostItemRequest(value: object): value is UpdateCostItemRequest {
    return true;
}

export function UpdateCostItemRequestFromJSON(json: any): UpdateCostItemRequest {
    return UpdateCostItemRequestFromJSONTyped(json, false);
}

export function UpdateCostItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCostItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'costType': json['costType'] == null ? undefined : json['costType'],
        'category': json['category'] == null ? undefined : json['category'],
        'status': json['status'] == null ? undefined : json['status'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'sunk': json['sunk'] == null ? undefined : json['sunk'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'version': json['version'] == null ? undefined : json['version'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function UpdateCostItemRequestToJSON(json: any): UpdateCostItemRequest {
    return UpdateCostItemRequestToJSONTyped(json, false);
}

export function UpdateCostItemRequestToJSONTyped(value?: UpdateCostItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'costType': value['costType'],
        'category': value['category'],
        'status': value['status'],
        'amount': value['amount'],
        'monthlyCost': value['monthlyCost'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'sunk': value['sunk'],
        'notes': value['notes'],
        'version': value['version'],
        'effectTenantId': value['effectTenantId'],
    };
}

